import { useContext, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import TopBar from './TopBar';
import SideNav from './SideNav';
import './Layout.css';

/**
 * Layout component that wraps pages with TopBar and SideNav
 * Automatically handles authentication check
 */
const Layout = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  if (loading) {
    return (
      <div className="layout-loading">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="layout">
      <TopBar onMenuToggle={toggleMobileMenu} />
      <SideNav isMobileOpen={isMobileMenuOpen} onClose={closeMobileMenu} />
      <main className="layout-content">
        {children}
      </main>
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
      )}
    </div>
  );
};

export default Layout;
